export default {
  YOUTUBE: 'YoutubeVideo',
  BRIGHTCOVE: 'BrightcoveVideo',
  LEGACY: 'Video',
};
